import { useState } from "react";
import clsx from "clsx";

interface Tab {
  title: string;
  content: React.ReactNode;
}

interface TabsProps {
  data: Tab[];
  tabsClass?: string;
  contentClass?: string;
}

const Tabs = ({ data, tabsClass = "", contentClass = "" }: TabsProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <ul className={clsx("tabs tabs-bordered justify-start lg:justify-center", tabsClass)}>
        {data.map((item, index) => (
          <li
            key={index}
            onClick={() => setActiveIndex(index)}
            className={clsx("tab w-28", index === activeIndex ? "tab-active font-bold" : "")}
          >
            {item.title}
          </li>
        ))}
      </ul>
      <div className={clsx("brand-text-sm p-4 text-base-content", contentClass)}>
        {typeof data[activeIndex]?.content === "string" ? (
          <div
            className="leading-loose"
            dangerouslySetInnerHTML={{ __html: data[activeIndex]?.content }}
          />
        ) : (
          data[activeIndex]?.content
        )}
      </div>
    </>
  );
};

export default Tabs;
